export default __webpack_public_path__ + "static/media/id.af166a84.svg";